module.exports = __webpack_public_path__ + "h5/img/languan_bg.95b7c8cb.png";